import { useStyles } from './HomeStyle'
import Card from '@material-ui/core/Card'
import img from '../../assets/images/banner.jpg'
import { Link } from 'react-router-dom'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import SportsTennisIcon from '@material-ui/icons/SportsTennis'
import React from 'react'
import HomeWorkIcon from '@material-ui/icons/HomeWork'
import pdf from '../../assets/ContactCentres.pdf'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ProfessorGrid from "../../components/ProfessorGrid/ProfessorGrid";
import ContactsIcon from '@material-ui/icons/Contacts';

export default function Home() {
  const classes = useStyles()

  return (
    <div className={classes.root} >
      <section className={classes.sectionHome}>
        <Card className={classes.card} style={{ backgroundImage: `url(${img})` }}>
          <div className={classes.text} >
            <div>
              <h1 style={{ width: '100%', textAlign: 'center', color: 'white' }}>
                Bienvenue sur le site AnimaNice.
              </h1>
              <img src={'/logo-blanc.png'} alt="logo" style={{ width: '100%', height: 'auto', maxWidth: 300 }} />
              <p>
                Vos centres AnimaNice vous accueillent toute l'année aux quatre coins de Nice et proposent des activités culturelles et de loisirs à toutes les générations. Quatre salles de spectacles, la Black Box, le Théâtre de la Tour, l’Espace Grappelli et Lou Mesclun complètent ce réseau.
              </p>
            </div>
          </div>


          <div className={classes.links}>
            <Link to="/login">
              <div>
                <AccountCircleIcon />
                <div>
                  <h3>Se connecter</h3>
                  <h4>Page de connexion à Animanice</h4>
                </div>
              </div>
            </Link>
            <Link to={pdf} target="_blank">
              <div>
                <HomeWorkIcon fontSize="large" />
                <div>
                  <h3>Centres</h3>
                  <h4>Listes des contacts des<br/> centres disponibles</h4>
                </div>
              </div>
            </Link>
          </div>
        </Card>
      </section>
    </div>
  )
}
